import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Label } from '../../../components/ui/Label';
import { Badge } from '../../../components/ui/Badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import { Modal } from '../../../components/ui/Modal';
import { 
  Webhook, 
  Plus, 
  Edit, 
  Trash2, 
  Play, 
  Pause, 
  Settings,
  BarChart3,
  Filter,
  Search,
  Save,
  RotateCcw,
  Eye,
  ArrowRight,
  ArrowDown,
  ArrowUp,
  Zap,
  Target,
  Clock,
  FileText,
  Download,
  Upload,
  TrendingUp,
  TrendingDown,
  Star,
  Crown,
  Shield,
  Activity,
  RefreshCw,
  Copy,
  ExternalLink,
  AlertTriangle,
  CheckCircle,
  UserCheck,
  Timer,
  Brain,
  Route,
  Zap as Lightning,
  Cpu,
  Database,
  Network,
  Monitor,
  UserPlus,
  UserMinus,
  Calendar,
  Mail,
  Phone,
  MessageSquare,
  Send,
  Archive,
  Unarchive,
  History,
  AlertCircle,
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  Clock3,
  CalendarDays,
  UserX,
  UserCog,
  UserSearch,
  UserEdit,
  Globe,
  Link,
  Key,
  Lock,
  Unlock,
  TestTube,
  Bug,
  Wifi,
  WifiOff,
  Server,
  Cloud,
  CloudOff,
  Terminal,
  Code,
  Hash,
  Layers,
  Box,
  Package,
  Archive as ArchiveIcon,
  File,
  Folder,
  FolderOpen,
  FileCode,
  FileJson,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileSpreadsheet,
  FilePdf,
  FileZip,
  FileCheck,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileSearch,
  FileSlash,
  FileWarning,
  FileQuestion,
  FileHeart,
  FileClock,
  FileUp,
  FileDown,
  FileLeft,
  FileRight,
  FileBarChart,
  FilePieChart,
  FileLineChart,
  FileScissors,
  FileType,
  FileSymlink,
  FileStack,
  FileTree,
  FileBinary,
  FileCog,
  FileSettings,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileCertificate,
  FileSignature,
  FileVerified,
  FileBadge,
  FileTag,
  FileLabel,
  FileBookmark,
  FileStar,
  FileFlag,
  FileAlert,
  FileInfo,
  FileHelp,
  FileMessage,
  FileComment,
  FileChat,
  FileMail,
  FilePhone,
  FileVideo as FileVideoIcon,
  FileAudio as FileAudioIcon,
  FileImage as FileImageIcon,
  FileSpreadsheet as FileSpreadsheetIcon,
  FilePdf as FilePdfIcon,
  FileZip as FileZipIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  FilePlus as FilePlusIcon,
  FileMinus as FileMinusIcon,
  FileEdit as FileEditIcon,
  FileSearch as FileSearchIcon,
  FileSlash as FileSlashIcon,
  FileWarning as FileWarningIcon,
  FileQuestion as FileQuestionIcon,
  FileHeart as FileHeartIcon,
  FileClock as FileClockIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileLeft as FileLeftIcon,
  FileRight as FileRightIcon,
  FileBarChart as FileBarChartIcon,
  FilePieChart as FilePieChartIcon,
  FileLineChart as FileLineChartIcon,
  FileScissors as FileScissorsIcon,
  FileType as FileTypeIcon,
  FileSymlink as FileSymlinkIcon,
  FileStack as FileStackIcon,
  FileTree as FileTreeIcon,
  FileBinary as FileBinaryIcon,
  FileCog as FileCogIcon,
  FileSettings as FileSettingsIcon,
  FileShield as FileShieldIcon,
  FileLock as FileLockIcon,
  FileUnlock as FileUnlockIcon,
  FileKey as FileKeyIcon,
  FileCertificate as FileCertificateIcon,
  FileSignature as FileSignatureIcon,
  FileVerified as FileVerifiedIcon,
  FileBadge as FileBadgeIcon,
  FileTag as FileTagIcon,
  FileLabel as FileLabelIcon,
  FileBookmark as FileBookmarkIcon,
  FileStar as FileStarIcon,
  FileFlag as FileFlagIcon,
  FileAlert as FileAlertIcon,
  FileInfo as FileInfoIcon,
  FileHelp as FileHelpIcon,
  FileMessage as FileMessageIcon,
  FileComment as FileCommentIcon,
  FileChat as FileChatIcon,
  FileMail as FileMailIcon,
  FilePhone as FilePhoneIcon
} from 'lucide-react';
import { useDataContext } from '../../../contexts/DataContext';

const WebhookConfiguration = () => {
  const navigate = useNavigate();
  const { getMockData, updateMockData } = useDataContext();
  
  // Define mock webhooks here so it's available for initialization
  const mockWebhooks = [
    {
      id: 1,
      name: "Ticket Created Webhook",
      description: "Notify external system when new tickets are created",
      url: "https://api.example.com/webhooks/ticket-created",
      events: ["ticket.created", "ticket.updated"],
      status: "active",
      isActive: true,
      secret: "whsec_1234567890abcdef",
      retryPolicy: { maxRetries: 3, retryDelay: "5m", backoffMultiplier: 2 },
      authentication: { type: "bearer_token", token: "Bearer abc123def456" },
      headers: { "Content-Type": "application/json", "User-Agent": "HelpDesk-Webhook/1.0" },
      createdAt: "2025-01-10T09:00:00Z",
      lastTriggered: "2025-01-15T14:30:00Z",
      successCount: 1247,
      failureCount: 23,
      successRate: 98.2
    },
    {
      id: 2,
      name: "User Registration Webhook",
      description: "Send user data to CRM system on registration",
      url: "https://crm.example.com/api/webhooks/user-registration",
      events: ["user.created", "user.updated"],
      status: "active",
      isActive: true,
      secret: "whsec_abcdef1234567890",
      retryPolicy: { maxRetries: 5, retryDelay: "2m", backoffMultiplier: 1.5 },
      authentication: { type: "api_key", key: "X-API-Key", value: "api_key_123456789" },
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      createdAt: "2025-01-08T14:20:00Z",
      lastTriggered: "2025-01-15T16:45:00Z",
      successCount: 892,
      failureCount: 8,
      successRate: 99.1
    },
    {
      id: 3,
      name: "Payment Status Webhook",
      description: "Update payment status in billing system",
      url: "https://billing.example.com/webhooks/payment-status",
      events: ["payment.completed", "payment.failed"],
      status: "testing",
      isActive: false,
      secret: "whsec_test123456789",
      retryPolicy: { maxRetries: 3, retryDelay: "10m", backoffMultiplier: 2 },
      authentication: { type: "basic_auth", username: "webhook_user", password: "webhook_pass" },
      headers: { "Content-Type": "application/json" },
      createdAt: "2025-01-12T11:30:00Z",
      lastTriggered: null,
      successCount: 0,
      failureCount: 0,
      successRate: 0
    },
    {
      id: 4,
      name: "SLA Breach Webhook",
      description: "Alert monitoring system when SLA is breached",
      url: "https://monitoring.example.com/alerts/sla-breach",
      events: ["ticket.sla_breached", "ticket.escalated"],
      status: "error",
      isActive: true,
      secret: "whsec_error123456789",
      retryPolicy: { maxRetries: 2, retryDelay: "15m", backoffMultiplier: 3 },
      authentication: { type: "bearer_token", token: "Bearer error_token_123" },
      headers: { "Content-Type": "application/json", "X-Alert-Level": "critical" },
      createdAt: "2025-01-05T08:15:00Z",
      lastTriggered: "2025-01-14T09:20:00Z",
      successCount: 156,
      failureCount: 45,
      successRate: 77.6
    },
    {
      id: 5,
      name: "Chat Message Webhook",
      description: "Forward chat messages to external chat system",
      url: "https://chat.example.com/api/webhooks/messages",
      events: ["chat.message_sent", "chat.message_received"],
      status: "inactive",
      isActive: false,
      secret: "whsec_inactive123456",
      retryPolicy: { maxRetries: 3, retryDelay: "5m", backoffMultiplier: 2 },
      authentication: { type: "api_key", key: "Authorization", value: "Token inactive_token_123" },
      headers: { "Content-Type": "application/json" },
      createdAt: "2025-01-03T16:45:00Z",
      lastTriggered: "2025-01-10T12:30:00Z",
      successCount: 234,
      failureCount: 12,
      successRate: 95.1
    }
  ];

  const [webhooks, setWebhooks] = useState(mockWebhooks);
  const [events, setEvents] = useState([]);
  const [logs, setLogs] = useState([]);
  const [isCreatingWebhook, setIsCreatingWebhook] = useState(false);
  const [editingWebhook, setEditingWebhook] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterEvent, setFilterEvent] = useState('all');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showMetricModal, setShowMetricModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    url: '',
    events: [],
    secret: '',
    retryPolicy: { maxRetries: 3, retryDelay: '5m', backoffMultiplier: 2 },
    authentication: { type: 'bearer_token', token: '' },
    headers: { 'Content-Type': 'application/json' }
  });

  useEffect(() => {
    loadWebhookData();
  }, []);

  const loadWebhookData = async () => {
    try {
      const data = getMockData('webhooks');
      const eventsData = getMockData('webhookEvents');
      const logsData = getMockData('webhookLogs');
      
      // Only update state if data exists, otherwise keep initial mock data
      if (data?.webhooks && data.webhooks.length > 0) {
        setWebhooks(data.webhooks);
      }
      if (eventsData?.events) {
        setEvents(eventsData.events);
      }
      if (logsData?.logs) {
        setLogs(logsData.logs);
      }
    } catch (error) {
      console.error('Failed to load webhook data:', error);
    }
  };

  const generateSecret = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = 'whsec_';
    for (let i = 0; i < 32; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const handleCreateWebhook = () => {
    setFormData({
      name: '',
      description: '',
      url: '',
      events: [],
      secret: generateSecret(),
      retryPolicy: { maxRetries: 3, retryDelay: '5m', backoffMultiplier: 2 },
      authentication: { type: 'bearer_token', token: '' },
      headers: { 'Content-Type': 'application/json' }
    });
    setShowCreateModal(true);
  };

  const handleSaveNewWebhook = () => {
    const newWebhook = {
      id: webhooks.length + 1,
      ...formData,
      status: 'active',
      isActive: true,
      createdAt: new Date().toISOString(),
      lastTriggered: null,
      successCount: 0,
      failureCount: 0,
      successRate: 0
    };
    
    alert(`Webhook created successfully!\n\nName: ${newWebhook.name}\nURL: ${newWebhook.url}\nSecret: ${newWebhook.secret}`);
    setShowCreateModal(false);
  };

  const handleEditWebhook = (webhook) => {
    setEditingWebhook(webhook);
    setFormData({
      name: webhook.name,
      description: webhook.description,
      url: webhook.url,
      events: webhook.events,
      secret: webhook.secret,
      retryPolicy: webhook.retryPolicy,
      authentication: webhook.authentication,
      headers: webhook.headers
    });
    setShowEditModal(true);
  };

  const handleSaveEditWebhook = () => {
    alert(`Webhook "${formData.name}" updated successfully!`);
    setShowEditModal(false);
    setEditingWebhook(null);
  };

  const handleDeleteWebhook = (webhookId) => {
    if (window.confirm('Are you sure you want to delete this webhook?')) {
      const updatedWebhooks = webhooks.filter(webhook => webhook.id !== webhookId);
      setWebhooks(updatedWebhooks);
      updateMockData('webhooks', { webhooks: updatedWebhooks });
    }
  };

  const handleToggleWebhook = (webhookId) => {
    const updatedWebhooks = webhooks.map(webhook => {
      if (webhook.id === webhookId) {
        const newStatus = webhook.status === 'active' ? 'inactive' : 'active';
        const newIsActive = newStatus === 'active';
        return { 
          ...webhook, 
          status: newStatus,
          isActive: newIsActive
        };
      }
      return webhook;
    });
    
    setWebhooks(updatedWebhooks);
    updateMockData('webhooks', { webhooks: updatedWebhooks });
    
    const updatedWebhook = updatedWebhooks.find(w => w.id === webhookId);
    alert(`Webhook "${updatedWebhook.name}" has been ${updatedWebhook.status === 'active' ? 'enabled' : 'disabled'} successfully!`);
  };

  const handleTestWebhook = (webhookId) => {
    const webhook = webhooks.find(w => w.id === webhookId);
    alert(`Testing webhook "${webhook.name}"...\n\n✓ Payload sent successfully\n✓ Response: 200 OK\n✓ Response Time: ${Math.floor(Math.random() * 500) + 100}ms\n\nTest completed successfully!`);
  };

  const handleRegenerateSecret = (webhookId) => {
    if (window.confirm('Are you sure you want to regenerate the webhook secret? This will invalidate the current secret.')) {
      const newSecret = generateSecret();
      alert(`Secret regenerated successfully!\n\nNew Secret: ${newSecret}\n\nPlease update your webhook configuration with the new secret.`);
    }
  };

  const handleTestAllWebhooks = () => {
    const activeWebhooks = webhooks.filter(w => w.isActive);
    alert(`Testing all active webhooks (${activeWebhooks.length})...\n\n${activeWebhooks.map(w => `✓ ${w.name}: Success`).join('\n')}\n\nAll tests completed!`);
  };

  const handleViewAnalytics = () => {
    navigate('/integration/analytics');
  };

  const handleConfigureSettings = () => {
    navigate('/integration/settings');
  };

  const handleMetricClick = (metric) => {
    setSelectedMetric(metric);
    setShowMetricModal(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'green';
      case 'inactive': return 'gray';
      case 'error': return 'red';
      case 'testing': return 'blue';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return CheckCircle;
      case 'inactive': return Pause;
      case 'error': return AlertTriangle;
      case 'testing': return TestTube;
      default: return AlertTriangle;
    }
  };

  const filteredWebhooks = webhooks.filter(webhook => {
    const matchesSearch = webhook.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         webhook.url.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         webhook.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || webhook.status === filterStatus;
    const matchesEvent = filterEvent === 'all' || webhook.events.includes(filterEvent);
    return matchesSearch && matchesStatus && matchesEvent;
  });

  const webhookMetrics = [
    {
      title: 'Total Webhooks',
      value: mockWebhooks.length,
      icon: Webhook,
      bgColor: '#006600',
      textColor: 'white',
      trend: '+2',
      trendDirection: 'up',
      details: {
        total: 5,
        active: 2,
        inactive: 1,
        testing: 1,
        error: 1,
        description: 'Total number of webhook configurations'
      }
    },
    {
      title: 'Active Webhooks',
      value: mockWebhooks.filter(w => w.status === 'active').length,
      icon: CheckCircle,
      bgColor: '#BB0000',
      textColor: 'white',
      trend: '+1',
      trendDirection: 'up',
      details: {
        production: 2,
        staging: 0,
        development: 0,
        avgResponseTime: '245ms',
        description: 'Currently active and operational webhooks'
      }
    },
    {
      title: 'Success Rate',
      value: '94.2%',
      icon: Target,
      bgColor: '#006600',
      textColor: 'white',
      trend: '+1.2%',
      trendDirection: 'up',
      details: {
        successful: 2356,
        failed: 146,
        total: 2502,
        description: 'Overall webhook delivery success rate'
      }
    },
    {
      title: 'Failed Deliveries',
      value: mockWebhooks.reduce((sum, w) => sum + w.failureCount, 0),
      icon: AlertTriangle,
      bgColor: '#BB0000',
      textColor: 'white',
      trend: '-5',
      trendDirection: 'down',
      details: {
        today: 23,
        yesterday: 28,
        thisWeek: 146,
        description: 'Total failed webhook deliveries requiring attention'
      }
    }
  ];

  const recentLogs = [
    {
      id: 1,
      webhookName: "Ticket Created Webhook",
      event: "ticket.created",
      status: "success",
      responseTime: "245ms",
      timestamp: "2025-01-15T14:30:00Z",
      statusCode: 200,
      payload: { ticketId: "TKT-2025-001", title: "Login Issues" }
    },
    {
      id: 2,
      webhookName: "User Registration Webhook",
      event: "user.created",
      status: "success",
      responseTime: "189ms",
      timestamp: "2025-01-15T16:45:00Z",
      statusCode: 201,
      payload: { userId: "USR-001", email: "user@example.com" }
    },
    {
      id: 3,
      webhookName: "SLA Breach Webhook",
      event: "ticket.sla_breached",
      status: "failed",
      responseTime: "5000ms",
      timestamp: "2025-01-14T09:20:00Z",
      statusCode: 500,
      payload: { ticketId: "TKT-2024-999", slaBreachTime: "2h" }
    }
  ];

  return (
    <div className="webhook-configuration p-5 bg-[#F8FCFB] min-h-screen">
      {/* Header */}
      <div className="mb-5 bg-white rounded-2xl shadow-sm p-5 border border-[#E5EFF3]">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-[#0B2530]">Webhook Configuration</h1>
            <p className="text-[#4A5B63] mt-1">Configure and test webhooks for external system integration</p>
          </div>
          <div className="flex items-center space-x-3">
            <Button 
              onClick={handleViewAnalytics}
              className="px-5 py-3 font-medium shadow-md transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <BarChart3 className="h-4 w-4 mr-2" />
              Analytics
            </Button>
            <Button 
              onClick={handleCreateWebhook}
              className="px-5 py-3 font-medium shadow-md transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <Plus className="h-4 w-4 mr-2" />
              Create Webhook
            </Button>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
        {webhookMetrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <Card 
              key={index} 
              className="hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105"
              onClick={() => handleMetricClick(metric)}
              style={{ 
                background: `linear-gradient(135deg, ${metric.bgColor} 0%, ${metric.bgColor}dd 100%)`,
                border: 'none'
              }}
            >
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium" style={{ color: metric.textColor }}>
                  {metric.title}
                </CardTitle>
                <Icon className="h-5 w-5" style={{ color: metric.textColor }} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold" style={{ color: metric.textColor }}>
                  {metric.value.toLocaleString ? metric.value.toLocaleString() : metric.value}
                </div>
                <div className="flex items-center text-sm mt-2" style={{ color: metric.textColor, opacity: 0.9 }}>
                  {metric.trendDirection === 'up' ? (
                    <ArrowUp className="h-4 w-4 mr-1" />
                  ) : (
                    <ArrowDown className="h-4 w-4 mr-1" />
                  )}
                  <span>{metric.trend} from last week</span>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Recent Activity */}
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Activity className="h-5 w-5 mr-2" />
            Recent Webhook Activity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {recentLogs.map((log) => (
              <div key={log.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div className="flex items-center space-x-3">
                  <Badge variant={log.status === 'success' ? 'default' : 'destructive'}>
                    {log.status}
                  </Badge>
                  <div>
                    <div className="font-medium">{log.webhookName}</div>
                    <div className="text-sm" style={{ color: '#4A5B63' }}>{log.event}</div>
                  </div>
                </div>
                <div className="text-right text-sm" style={{ color: '#4A5B63' }}>
                  <div>{log.responseTime}</div>
                  <div>{log.statusCode}</div>
                  <div>{new Date(log.timestamp).toLocaleString()}</div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Filters and Search */}
      <Card className="mb-6 shadow-md border-[#E5EFF3]">
        <CardHeader className="bg-gradient-to-r from-[#F8FCFB] to-white border-b border-[#E5EFF3]">
          <CardTitle className="flex items-center text-[#0B2530]">
            <Filter className="h-5 w-5 mr-2" style={{ color: '#006600' }} />
            Filter Webhooks
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search 
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 z-10" 
                  style={{ color: '#8A9AA2' }}
                />
                <Input
                  placeholder="Search webhooks by name, URL, or event type..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-12 pr-4 py-3 text-base border-2 focus:border-[#006600] focus:ring-2 focus:ring-[#006600]/20 rounded-xl transition-all shadow-sm"
                  style={{
                    borderColor: searchTerm ? '#006600' : '#E2E8F0',
                    backgroundColor: searchTerm ? '#E8FCF7' : 'white'
                  }}
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Select value={filterStatus} onValueChange={setFilterStatus}>
                <SelectTrigger 
                  className="w-full sm:w-48 h-12 border-2 rounded-xl shadow-sm transition-all hover:border-[#006600]"
                  style={{
                    borderColor: filterStatus !== 'all' ? '#006600' : '#E2E8F0'
                  }}
                >
                  <SelectValue placeholder="Filter by status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Status</SelectItem>
                  <SelectItem value="active">Active</SelectItem>
                  <SelectItem value="inactive">Inactive</SelectItem>
                  <SelectItem value="testing">Testing</SelectItem>
                  <SelectItem value="error">Error</SelectItem>
                </SelectContent>
              </Select>
              <Select value={filterEvent} onValueChange={setFilterEvent}>
                <SelectTrigger 
                  className="w-full sm:w-48 h-12 border-2 rounded-xl shadow-sm transition-all hover:border-[#006600]"
                  style={{
                    borderColor: filterEvent !== 'all' ? '#006600' : '#E2E8F0'
                  }}
                >
                  <SelectValue placeholder="Filter by event" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Events</SelectItem>
                  <SelectItem value="ticket.created">Ticket Created</SelectItem>
                  <SelectItem value="user.created">User Created</SelectItem>
                  <SelectItem value="payment.completed">Payment Completed</SelectItem>
                  <SelectItem value="chat.message_sent">Chat Message</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Webhooks List */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Webhook className="h-5 w-5 mr-2" />
            Webhook Configurations ({webhooks.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {webhooks.map((webhook) => {
              const StatusIcon = getStatusIcon(webhook.status);
              return (
                <div key={webhook.id} className="p-6 border rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h3 className="text-lg font-semibold">{webhook.name}</h3>
                        <Badge variant={webhook.status === 'active' ? 'default' : 'secondary'}>
                          <StatusIcon className="h-3 w-3 mr-1" />
                          {webhook.status}
                        </Badge>
                        <Badge variant="outline" className="flex items-center">
                          <Globe className="h-3 w-3 mr-1" />
                          {webhook.url.split('/')[2]}
                        </Badge>
                      </div>
                      <p className="text-gray-600 mb-3">{webhook.description}</p>
                      
                      {/* Webhook Details */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Configuration:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">URL:</span> {webhook.url}
                          </div>
                          <div>
                            <span className="font-medium">Events:</span> {webhook.events.length}
                          </div>
                          <div>
                            <span className="font-medium">Auth:</span> {webhook.authentication.type}
                          </div>
                          <div>
                            <span className="font-medium">Retries:</span> {webhook.retryPolicy.maxRetries}
                          </div>
                        </div>
                      </div>

                      {/* Events */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Events:</h4>
                        <div className="flex flex-wrap gap-2">
                          {webhook.events.map((event, index) => (
                            <Badge key={index} variant="outline" className="text-xs">
                              {event}
                            </Badge>
                          ))}
                        </div>
                      </div>

                      {/* Performance Metrics */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Performance:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Success Rate:</span> {webhook.successRate}%
                          </div>
                          <div>
                            <span className="font-medium">Success Count:</span> {webhook.successCount}
                          </div>
                          <div>
                            <span className="font-medium">Failure Count:</span> {webhook.failureCount}
                          </div>
                          <div>
                            <span className="font-medium">Last Triggered:</span> {webhook.lastTriggered ? new Date(webhook.lastTriggered).toLocaleDateString() : 'Never'}
                          </div>
                        </div>
                      </div>

                      {/* Timestamps */}
                      <div className="flex items-center space-x-6 text-sm text-gray-600">
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>Created: {new Date(webhook.createdAt).toLocaleString()}</span>
                        </div>
                        <div className="flex items-center">
                          <Key className="h-4 w-4 mr-1" />
                          <span>Secret: {webhook.secret.substring(0, 20)}...</span>
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-2 ml-4">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleTestWebhook(webhook.id)}
                      >
                        <TestTube className="h-3 w-3 mr-1" />
                        Test
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleRegenerateSecret(webhook.id)}
                      >
                        <Key className="h-3 w-3 mr-1" />
                        Regenerate
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleEditWebhook(webhook)}
                      >
                        <Edit className="h-3 w-3 mr-1" />
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleToggleWebhook(webhook.id)}
                      >
                        {webhook.isActive ? (
                          <>
                            <Pause className="h-3 w-3 mr-1" />
                            Disable
                          </>
                        ) : (
                          <>
                            <Play className="h-3 w-3 mr-1" />
                            Enable
                          </>
                        )}
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleDeleteWebhook(webhook.id)}
                      >
                        <Trash2 className="h-3 w-3 mr-1" />
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="h-5 w-5 mr-2" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Button onClick={handleCreateWebhook} className="h-20 flex flex-col items-center justify-center space-y-2">
              <Plus className="h-6 w-6" />
              <span>Create Webhook</span>
            </Button>
            <Button variant="outline" onClick={handleTestAllWebhooks} className="h-20 flex flex-col items-center justify-center space-y-2">
              <TestTube className="h-6 w-6" />
              <span>Test All Webhooks</span>
            </Button>
            <Button variant="outline" onClick={handleViewAnalytics} className="h-20 flex flex-col items-center justify-center space-y-2">
              <BarChart3 className="h-6 w-6" />
              <span>View Analytics</span>
            </Button>
            <Button variant="outline" onClick={handleConfigureSettings} className="h-20 flex flex-col items-center justify-center space-y-2">
              <Settings className="h-6 w-6" />
              <span>Configure Settings</span>
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Create Webhook Modal */}
      <Modal isOpen={showCreateModal} onClose={() => setShowCreateModal(false)}>
        <div className="max-w-3xl -m-6">
          {/* Modal Header */}
          <div className="gradient-hero px-6 py-5 rounded-t-lg relative">
            <button
              onClick={() => setShowCreateModal(false)}
              className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/10 rounded-lg p-2 transition-all duration-200"
              aria-label="Close"
            >
              <XCircle className="h-6 w-6" />
            </button>
            <div className="flex items-center space-x-3 pr-12">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                <Plus className="h-6 w-6 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">Create New Webhook</h2>
                <p className="text-white/90 text-sm mt-1">Configure webhook for external system integration</p>
              </div>
            </div>
          </div>

          <div className="p-5 space-y-4 max-h-[70vh] overflow-y-auto">
            {/* Basic Information Section */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 pb-3 border-b border-border">
                <Info className="h-5 w-5" style={{ color: '#006600' }} />
                <h3 className="text-lg font-semibold text-foreground">Basic Information</h3>
              </div>

              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Webhook className="h-4 w-4 mr-2" style={{ color: '#006600' }} />
                    Webhook Name <span className="text-red-500 ml-1">*</span>
                  </Label>
                  <Input
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    placeholder="e.g., Ticket Created Webhook"
                    className="border-2 h-11"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">A descriptive name for this webhook</p>
                </div>

                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <FileText className="h-4 w-4 mr-2" style={{ color: '#000000' }} />
                    Description
                  </Label>
                  <Input
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    placeholder="Brief description of the webhook's purpose"
                    className="border-2 h-11"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">Optional description for documentation</p>
                </div>

                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Link className="h-4 w-4 mr-2" style={{ color: '#006600' }} />
                    Endpoint URL <span className="text-red-500 ml-1">*</span>
                  </Label>
                  <Input
                    value={formData.url}
                    onChange={(e) => setFormData({...formData, url: e.target.value})}
                    placeholder="https://api.example.com/webhooks/..."
                    className="border-2 h-11 font-mono text-sm"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">The URL where webhook events will be sent</p>
                </div>
              </div>
            </div>

            {/* Security Section */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 pb-3 border-b border-border">
                <Shield className="h-5 w-5" style={{ color: '#BB0000' }} />
                <h3 className="text-lg font-semibold text-foreground">Security Configuration</h3>
              </div>

              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Key className="h-4 w-4 mr-2" style={{ color: '#006600' }} />
                    Secret Key (auto-generated)
                  </Label>
                  <div className="relative">
                    <Input
                      value={formData.secret}
                      readOnly
                      className="border-2 h-11 font-mono text-sm bg-gray-50"
                      style={{ borderColor: '#e0e0e0' }}
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(formData.secret)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      title="Copy to clipboard"
                    >
                      <Copy className="h-4 w-4" />
                    </button>
                  </div>
                  <p className="text-xs text-muted-foreground">Use this secret to verify webhook requests</p>
                </div>

                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Lock className="h-4 w-4 mr-2" style={{ color: '#BB0000' }} />
                    Authentication Type <span className="text-red-500 ml-1">*</span>
                  </Label>
                  <Select value={formData.authentication.type} onValueChange={(value) => setFormData({...formData, authentication: {...formData.authentication, type: value}})}>
                    <SelectTrigger className="h-11 border-2" style={{ borderColor: '#e0e0e0' }}>
                      <SelectValue placeholder="Select authentication type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="bearer_token">Bearer Token</SelectItem>
                      <SelectItem value="api_key">API Key</SelectItem>
                      <SelectItem value="basic_auth">Basic Auth</SelectItem>
                    </SelectContent>
                  </Select>
                  <p className="text-xs text-muted-foreground">Authentication method for webhook requests</p>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="px-6 py-4 bg-[#F8FCFB] rounded-b-lg border-t border-border flex justify-end space-x-3">
            <Button
              variant="outline"
              onClick={() => setShowCreateModal(false)}
              className="px-6 py-3 border-2 hover:bg-[#E0F8F3] transition-all duration-200"
              style={{ borderColor: '#e0e0e0' }}
            >
              <XCircle className="h-4 w-4 mr-2" />
              Cancel
            </Button>
            <Button
              onClick={handleSaveNewWebhook}
              className="px-6 py-3 text-white transition-all duration-300 hover:shadow-lg transform hover:-translate-y-0.5"
              style={{
                background: 'linear-gradient(135deg, #006600 0%, #006600 100%)',
                border: 'none'
              }}
            >
              <Plus className="h-4 w-4 mr-2" />
              Create Webhook
            </Button>
          </div>
        </div>
      </Modal>

      {/* Edit Webhook Modal */}
      <Modal isOpen={showEditModal} onClose={() => setShowEditModal(false)}>
        <div className="max-w-3xl -m-6">
          {/* Modal Header */}
          <div className="gradient-hero px-6 py-5 rounded-t-lg relative">
            <button
              onClick={() => setShowEditModal(false)}
              className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/10 rounded-lg p-2 transition-all duration-200"
              aria-label="Close"
            >
              <XCircle className="h-6 w-6" />
            </button>
            <div className="flex items-center space-x-3 pr-12">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                <Edit className="h-6 w-6 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">Edit Webhook</h2>
                <p className="text-white/90 text-sm mt-1">Update webhook configuration and settings</p>
              </div>
            </div>
          </div>

          <div className="p-5 space-y-4 max-h-[70vh] overflow-y-auto">
            {/* Basic Information Section */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 pb-3 border-b border-border">
                <Info className="h-5 w-5" style={{ color: '#006600' }} />
                <h3 className="text-lg font-semibold text-foreground">Webhook Configuration</h3>
              </div>

              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Webhook className="h-4 w-4 mr-2" style={{ color: '#006600' }} />
                    Webhook Name <span className="text-red-500 ml-1">*</span>
                  </Label>
                  <Input
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    placeholder="e.g., Chat Message Webhook"
                    className="border-2 h-11"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">A descriptive name for this webhook</p>
                </div>

                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <FileText className="h-4 w-4 mr-2" style={{ color: '#000000' }} />
                    Description
                  </Label>
                  <Input
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    placeholder="Forward chat messages to external chat system"
                    className="border-2 h-11"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">Optional description for documentation</p>
                </div>

                <div className="space-y-2">
                  <Label className="flex items-center text-sm font-semibold text-foreground">
                    <Link className="h-4 w-4 mr-2" style={{ color: '#006600' }} />
                    Endpoint URL <span className="text-red-500 ml-1">*</span>
                  </Label>
                  <Input
                    value={formData.url}
                    onChange={(e) => setFormData({...formData, url: e.target.value})}
                    placeholder="https://chat.example.com/api/webhooks/messages"
                    className="border-2 h-11 font-mono text-sm"
                    style={{ borderColor: '#e0e0e0' }}
                  />
                  <p className="text-xs text-muted-foreground">The URL where webhook events will be sent</p>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="px-6 py-4 bg-[#F8FCFB] rounded-b-lg border-t border-border flex justify-end space-x-3">
            <Button
              variant="outline"
              onClick={() => setShowEditModal(false)}
              className="px-6 py-3 border-2 hover:bg-[#E0F8F3] transition-all duration-200"
              style={{ borderColor: '#e0e0e0' }}
            >
              <XCircle className="h-4 w-4 mr-2" />
              Cancel
            </Button>
            <Button
              onClick={handleSaveEditWebhook}
              className="px-6 py-3 text-white transition-all duration-300 hover:shadow-lg transform hover:-translate-y-0.5"
              style={{
                background: 'linear-gradient(135deg, #006600 0%, #006600 100%)',
                border: 'none'
              }}
            >
              <Save className="h-4 w-4 mr-2" />
              Save Changes
            </Button>
          </div>
        </div>
      </Modal>

      {/* Metric Detail Modal */}
      {selectedMetric && (
        <Modal isOpen={showMetricModal} onClose={() => setShowMetricModal(false)}>
          <div className="max-w-2xl -m-6">
            <div 
              className="px-8 py-6 rounded-t-lg relative"
              style={{ 
                background: `linear-gradient(135deg, ${selectedMetric.bgColor} 0%, ${selectedMetric.bgColor}dd 100%)`,
                color: 'white'
              }}
            >
              <button
                onClick={() => setShowMetricModal(false)}
                className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/10 rounded-lg p-2 transition-all duration-200"
                aria-label="Close"
              >
                <XCircle className="h-6 w-6" />
              </button>
              <div className="flex items-center justify-between mb-4 pr-12">
                <h2 className="text-2xl font-bold">{selectedMetric.title}</h2>
                {React.createElement(selectedMetric.icon, { className: 'h-10 w-10' })}
              </div>
              <div className="text-4xl font-bold mb-2">
                {selectedMetric.value.toLocaleString ? selectedMetric.value.toLocaleString() : selectedMetric.value}
              </div>
              <div className="flex items-center text-lg" style={{ opacity: 0.9 }}>
                {selectedMetric.trendDirection === 'up' ? (
                  <ArrowUp className="h-5 w-5 mr-2" />
                ) : (
                  <ArrowDown className="h-5 w-5 mr-2" />
                )}
                <span>{selectedMetric.trend} from last week</span>
              </div>
            </div>

            <div className="p-8 space-y-4">
              <p className="text-gray-700 text-lg">{selectedMetric.details.description}</p>
              
              <div className="grid grid-cols-2 gap-4 mt-6">
                {Object.entries(selectedMetric.details).map(([key, value]) => {
                  if (key === 'description') return null;
                  return (
                    <div key={key} className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                      <div className="text-sm text-gray-600 capitalize mb-1">
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </div>
                      <div className="text-2xl font-bold" style={{ color: selectedMetric.bgColor }}>
                        {value.toLocaleString ? value.toLocaleString() : value}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-end mt-6 space-x-2">
                <Button 
                  variant="outline" 
                  onClick={() => setShowMetricModal(false)}
                  className="hover:bg-gray-100 transition-all"
                  style={{
                    borderColor: selectedMetric.bgColor,
                    color: selectedMetric.bgColor
                  }}
                >
                  Close
                </Button>
                <Button 
                  onClick={() => {
                    setShowMetricModal(false);
                    handleViewAnalytics();
                  }}
                  className="transition-all hover:scale-105"
                  style={{
                    background: `linear-gradient(135deg, ${selectedMetric.bgColor} 0%, ${selectedMetric.bgColor}dd 100%)`,
                    color: 'white',
                    border: 'none'
                  }}
                >
                  <BarChart3 className="h-4 w-4 mr-2" />
                  View Analytics
                </Button>
                <Button 
                  onClick={() => {
                    setShowMetricModal(false);
                    handleTestAllWebhooks();
                  }}
                  className="transition-all hover:scale-105"
                  style={{
                    background: 'linear-gradient(135deg, #006600 0%, #006600 100%)',
                    color: 'white',
                    border: 'none'
                  }}
                >
                  <TestTube className="h-4 w-4 mr-2" />
                  Test All
                </Button>
                <Button 
                  onClick={() => {
                    setShowMetricModal(false);
                    handleConfigureSettings();
                  }}
                  className="transition-all hover:scale-105"
                  style={{
                    background: 'linear-gradient(135deg, #006600 0%, #006600 100%)',
                    color: 'white',
                    border: 'none'
                  }}
                >
                  <Settings className="h-4 w-4 mr-2" />
                  Configure
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default WebhookConfiguration;
